// Motivo do cancelamento do boleto em lista fechada (#6509), nas duas telas que cancelam:
// Boleto emitido e Cobrança enviada. A lista e o texto gravado estão em
// src/lib/motivosCancelamentoBoleto.ts.
import React from 'react';
import { MOTIVOS_CANCELAMENTO_BOLETO, motivoPorCodigo } from '../../../src/lib/motivosCancelamentoBoleto';

export interface MotivoCancelamentoEscolhido { codigo: string; detalhe: string }
export const SEM_MOTIVO_CANCELAMENTO: MotivoCancelamentoEscolhido = { codigo: '', detalhe: '' };

const GRUPOS = [
  { rotulo: 'Pedido do cliente ou mudança na conta', itens: MOTIVOS_CANCELAMENTO_BOLETO.filter(m => !m.erroDoFaturamento && !m.foraDaConta && !m.exigeDetalhe) },
  { rotulo: 'Erro na emissão', itens: MOTIVOS_CANCELAMENTO_BOLETO.filter(m => m.erroDoFaturamento) },
  { rotulo: 'Outros', itens: MOTIVOS_CANCELAMENTO_BOLETO.filter(m => m.foraDaConta || m.exigeDetalhe) },
];

export const CampoMotivoCancelamento: React.FC<{
  valor: MotivoCancelamentoEscolhido;
  aoMudar: (v: MotivoCancelamentoEscolhido) => void;
}> = ({ valor, aoMudar }) => {
  const escolhido = motivoPorCodigo(valor.codigo);
  return (
    <div className="mb-6 text-left space-y-2">
      <label htmlFor="motivo-cancelamento-boleto" className="block text-sm font-semibold text-gray-700 dark:text-gray-300">
        Motivo do cancelamento <span className="text-red-500">*</span>
      </label>
      <select
        id="motivo-cancelamento-boleto"
        value={valor.codigo}
        onChange={(e) => aoMudar({ ...valor, codigo: e.target.value })}
        className="w-full px-3 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-primary/50"
      >
        <option value="">Escolha o motivo…</option>
        {GRUPOS.map(g => (
          <optgroup key={g.rotulo} label={g.rotulo}>
            {g.itens.map(m => <option key={m.codigo} value={m.codigo}>{m.rotulo}</option>)}
          </optgroup>
        ))}
      </select>
      {escolhido?.dica && <p className="text-xs text-gray-500 dark:text-gray-400">{escolhido.dica}</p>}
      <textarea
        value={valor.detalhe}
        onChange={(e) => aoMudar({ ...valor, detalhe: e.target.value })}
        placeholder={escolhido?.exigeDetalhe ? 'Descreva o motivo (obrigatório)…' : 'Detalhe (opcional): o que estava errado ou o que o cliente pediu…'}
        className="w-full px-3 py-3 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-primary/50 resize-none h-20"
      />
    </div>
  );
};
